<template>
  <div>
      <h2>我的证书</h2>
      <a-divider></a-divider>
      <iframe width="100%" height="800px" src="/cert/query.html" frameborder="no"></iframe>
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>